"use client";

import { createContext, useContext } from "react";
import type { ContactSalesOrigin } from "../types";

export interface ContactSalesContextValue {
  isOpen: boolean;
  origin: ContactSalesOrigin | null;
  open: (origin: ContactSalesOrigin) => void;
  close: () => void;
}

export const ContactSalesContext = createContext<ContactSalesContextValue | null>(null);

export function useContactSales(): ContactSalesContextValue {
  const ctx = useContext(ContactSalesContext);
  if (!ctx) {
    throw new Error("useContactSales must be used inside <ContactSalesProvider>");
  }
  return ctx;
}
